import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CostCenterService } from '../proxy/controlling/controllers/cost-center.service';
import { InternalOrderTypeService } from '../proxy/controlling/controllers/internal-order-type.service';
import { ProjectTypeService } from '@woodsupply/proxy/wood-supply/controllers/project-type.service';

FieldBuilder.setNamespace('Controlling');

export const INTERNALORDER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InternalOrder.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.InternalOrder.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('oldSapCode', 'Entity.InternalOrder.OldSapCode')
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isVisible', 'Entity.InternalOrder.IsVisible')
    .build(),
  FieldBuilder
    .foreignKey('internalOrderTypeId', 'Entity.InternalOrderType', InternalOrderTypeService)
    .displayFromNested('internalOrderType.name')
    .sortBy('internalOrderType.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('projectTypeId', 'Entity.InternalOrder.ProjectType', ProjectTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('oldCostCenterId', 'Entity.InternalOrder.OldCostCenter', CostCenterService)
    .displayFromNested('oldCostCenter.name')
    .sortBy('oldCostCenter.name')
    .build(),
  FieldBuilder
    .foreignKey('costCenterId', 'Entity.CostCenter', CostCenterService)
    .displayFromNested('costCenter.sapCode')
    .sortBy('costCenter.sapCode')
    .build(),
];

export const INTERNALORDER_CONFIG = {
  entityName: 'InternalOrder',
  localizationKey: 'Controlling::Entity.InternalOrder',
  fields: INTERNALORDER_FIELDS,
  permission: 'ControllingSap.InternalOrders',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
